import React from 'react'
import simg from '../../images/mission-shape.png'


const MissionVission = ({props, settings}) => {
    return (
        <section 
            className="wpo-mission-vission-section section-padding"
            style={{
                backgroundColor: "#E6F7FF",
                backgroundImage: "linear-gradient(to bottom right, #E6F7FF, #F0FBFF)",
                paddingTop: "40px",   // reduce vertical padding
                paddingBottom: "40px" // reduce vertical padding
            }}
        >
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-12 col-12">
                        <div className="wpo-mission-item">
                            <div className="wpo-mission-text">
                                <h2>Our Mission</h2>
                                <p
                                    style={{
                                        textAlign: "justify"
                                    }}
                                    dangerouslySetInnerHTML={{
                                        __html: settings.mission
                                    }}
                                />
                                <h5>{settings.motto}</h5>
                            </div>
                            <div className="shape-1"></div>
                            <div className="shape-2"><img src={simg} alt=""/></div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-12">
                        <div className="wpo-vission-item">
                            <div className="wpo-vission-text">
                                <h2>Our Vission</h2>
                                <h5
                                    style={{
                                        textAlign: "justify"
                                    }}
                                    dangerouslySetInnerHTML={{
                                        __html: settings.coreValue
                                    }}
                                />
                                <p
                                    style={{
                                        textAlign: "justify"
                                    }}
                                    dangerouslySetInnerHTML={{
                                        __html: settings.vision
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default MissionVission;